/*
 * HE.Editor
 * TinyMCE WYSIWYG text editor shim
 * https://www.tinymce.com/docs/
 */

(function Editors($, HE, tinymce)
{
	"use strict";

	/* var script_url_whitelist = [
	        'form.jotform.com',
	        'assets.freshdesk.com',
	        'reviews.sproutloud.com',
	        'platform.reviewmgr.com',
	        'static.reviewmgr.com',
	        'www.tiktok.com',
			'widgets.meetsoci.com',
	]; */

	var editor = function Editor(el, options)
	{
		var self = this,
		    menubar_sets = {
		        // when adding menubars, please keep them in alphabetical order
		        // to make them easier to manage
				basic  : false,
				manager: 'edit insert view format table tools',
				web    : 'edit insert view format table tools',
		    },
		    plugin_sets = {
		        // when adding plugins, please keep them in alphabetical order
		        // to make them easier to manage
				basic  : 'link lists',
				manager: 'anchor code image link lists preview table media grid',
				web    : 'anchor code image link lists preview table media',
		    },
		    toolbar_sets = {
		        // when adding toolbars, please keep them in alphabetical order
		        // to make them easier to manage
				basic: [
					'bold italic underline | bullist numlist | link unlink | removeformat | undo redo',
				],
				manager: [
					'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image media code | table grid_insert charmap emoticons | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
				],
		        web: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image media code | table charmap emoticons | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
		        ],
		    },
		    statusbar_sets = {
		        // when adding status bar, please keep them in alphabetical order
		        // to make them easier to manage
				basic  : false,
				manager: true,
				web    : true,
		    },
		    // text formatting and links only -- anything else (images, media,
		    // tables, pasted markup) is stripped rather than stored
		    valid_elements_sets = {
				basic: 'p,br,strong/b,em/i,u,ul,ol,li,a[href|target|title|rel]',
		    },

		    defaults = {
				menubar           : menubar_sets.web,
				plugins           : plugin_sets.web,
				toolbar           : toolbar_sets.web,
				statusbar         : statusbar_sets.web,
				contextmenu       : false,
				removed_menuitems : 'newdocument',
				image_advtab      : true,
				browser_spellcheck: true,
				relative_urls     : false,
				remove_script_host: false,
				promotion         : false,
				branding          : false,
				automatic_uploads : true,
		        setup             : function _setup(editor)
		        {
		            editor.on('change', function _change() {
		                _updateHiddenInput(editor);
		            });

		            // save internal reference to the tinymce editor itself
		            self._editor = editor;
		        },
		    },
		    _updateHiddenInput = HE.Debounce(function __updateHiddenInput(editor) {
		        // this syncs the hidden input's value with tinymce's contents
		        editor.save();

		        // this syncs EVERY tinymce editor on the page
		        // tinymce.triggerSave();
		    }, 250),
		    opts = $.extend({}, defaults, options),
		    editor_type,
		    editorElement;

		try
		{
			if ($.isEmptyObject(tinymce)) {
				throw new Error('TinyMCE is not loaded.');
			}

			if ((this instanceof Editor) === false) {
				return new Editor(el, options);
			}

			if (typeof el === 'string') {
				editorElement = el;
				this.$editor  = $(editorElement);
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				throw new Error("jQuery objects are not supported.");
			}

			if (!this.$editor.length) {
				throw new Error('cannot find ' + editorElement);
			}

			opts.selector    = editorElement;
			opts.license_key = 'gpl';

			// editor type set via form data attribute
			if (this.$editor.data('editor-type') !== undefined) {
				editor_type = this.$editor.data('editor-type');
			}

			// editor type being set via JS call to HE.Editor
			if (opts.editor_type !== undefined) {
				editor_type = opts.editor_type;
			}

			if (editor_type !== undefined) {
				opts.menubar   = menubar_sets[editor_type];
				opts.plugins   = plugin_sets[editor_type];
				opts.toolbar   = toolbar_sets[editor_type];
				opts.statusbar = statusbar_sets[editor_type];

				if (valid_elements_sets[editor_type] !== undefined) {
					opts.valid_elements = valid_elements_sets[editor_type];
				}
			}


			// if we have to add insecure shit due to agents requesting it
			// at least we can /try/ to make it decent with a whitelist
			opts.extended_valid_elements = 'video[controls|playsinline|width|height|autoplay|muted],source[src|type],script[type=text/javascript|src]';
			/* opts.urlconverter_callback   = function validateUrl(url, node, on_save, name)
			{
				var script,
				    mce_settings = self._editor.settings;

				// parse the script url, check if hostname is in whitelist
				if (node === 'script')
				{
					script = document.createElement('a');
					script.href = url;

					if (script_url_whitelist.indexOf(script.hostname) >= 0) {
						return url;
					}

					return '';
				}

				// port of original tinymce.convertURL() functionality
				// without recursively calling the urlconverter_callback function
				if (
					!mce_settings.convert_urls ||
					node === "a" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'a') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (
					!mce_settings.convert_urls ||
					node === "img" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'img') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (mce_settings.relative_urls) {
					// console.log('documentBaseURI.toRelative', self._editor.documentBaseURI.toRelative(url));
					return self._editor.documentBaseURI.toRelative(url);
				}

				// console.log('documentBaseURI.toAbsolute', self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host));
				return self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host);
			}; */

			// set base path for icons, plugins, skins, and themes
			tinymce.baseURL = HE.base_uri + '/js/vendor/tinymce';

			// remove any tinymce instances that are already initialized for this el
			tinymce.remove(editorElement);

			// tinymce 5 doesn't allow us to extend the default colormap
			// list of available colors, so set all of the stock ones here
			// and add the cruise planners one as well.
			// the weird structure is legit, not a typo. idunno, man.
			opts.color_map = [
				'#BFEDD2', 'Light Green',
				'#FBEEB8', 'Light Yellow',
				'#F8CAC6', 'Light Red',
				'#ECCAFA', 'Light Purple',
				'#C2E0F4', 'Light Blue',
				'#2DC26B', 'Green',
				'#F1C40F', 'Yellow',
				'#E03E2D', 'Red',
				'#B96AD9', 'Purple',
				'#3598DB', 'Blue',
				'#169179', 'Dark Turquoise',
				'#E67E23', 'Orange',
				'#BA372A', 'Dark Red',
				'#843FA1', 'Dark Purple',
				'#236FA1', 'Dark Blue',
				'#ECF0F1', 'Light Gray',
				'#CED4D9', 'Medium Gray',
				'#95A5A6', 'Gray',
				'#7E8C8D', 'Dark Gray',
				'#34495E', 'Navy Blue',
				'#000000', 'Black',
				'#FFFFFF', 'White',
				"#3AAF49", "Cruise Planners Green",
			];

			// tinymce 5 changed how height works, this compensates for the change
			// this only works if a height is specified
			if (opts.height) {
				opts.height += 170;
			}
			else {
				// tinymce5's default height seems a bit smaller than before
				// so this'll make them look about the same
				opts.height = 300;
			}


			// the basic editor gets no uploads at all: no image picker (which
			// would also put a browse button in the link dialog), and pasted
			// or dropped images are refused instead of uploaded
			if (editor_type === 'basic') {
				opts.automatic_uploads      = false;
				opts.paste_data_images      = false;
				opts.block_unsupported_drop = true;
			}
			else {
				// support image uploading
				// function(blobInfo, successHandler, failureHandler)
				if (typeof opts.images_upload_handler !== 'function'
					&& this.$editor.data('image-upload-url') !== undefined)
				{
					opts.images_upload_url = HE.get_url(this.$editor.data('image-upload-url'));
				}

				opts.media_live_embeds  = true;
				opts.file_picker_types  = 'file image';
				opts.automatic_uploads  = true;
				opts.images_upload_url  = HE.base_uri+ '/Hotels/uploadTinyMceImages';

				opts.file_picker_callback =  function imagePicker(cb, value, meta) {
					const input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('accept', 'image/*');

					console.log(value, 'value');
					console.log(meta, 'meta');

					input.addEventListener('change', (e) => {
						const file = e.target.files[0];
						const reader = new FileReader();
						reader.addEventListener('load', () => {
							/*
							  Note: Now we need to register the blob in TinyMCEs image blob
							  registry. In the next release this part hopefully won't be
							  necessary, as we are looking to handle it internally.
							*/

							const id = 'blobid' + (new Date()).getTime();
							const blobCache = tinymce.activeEditor.editorUpload.blobCache;
							const base64 = reader.result.split(',')[1];
							const blobInfo = blobCache.create(id, file, base64);
							blobCache.add(blobInfo);

							/* call the callback and populate the Title field with the file name */
							cb(blobInfo.blobUri(), {title: file.name});
						});
						reader.readAsDataURL(file);
					});

					input.click();
				};
			}

			console.log(opts, 'opts');
			// init
			tinymce.init(opts).then(function ready(editors) {
				self.$editor.trigger('editor.ready', editors[0]);
			});

			this.$editor.addClass('has-html');
		}
		catch (err)
		{
			console.log('[HE.Editor]', err);
		}
	};

	HE.Editor = editor;
}(jQuery, window.HE || {}, window.tinymce || {}));
